import { CategoryPage } from "@outschool/gql-backend-generated";
import { TFunction, useTranslation } from "@outschool/localization";
import React from "react";

function makeRelatedCategoriesHeading(
  category: CategoryPage,
  t: TFunction
): string {
  if (category && category.nameSentenceCased != "uncategorized") {
    const categoryName = category.nameSentenceCased;
    return t("Explore more in {{categoryName}}", { categoryName });
  }
  return t("Explore more");
}

export function useTranslateRelatedCategoriesHeading() {
  const { t } = useTranslation(
    "client\\components\\categories\\hooks\\RelatedCategoriesHeading"
  );

  return React.useCallback(
    (category: CategoryPage) => makeRelatedCategoriesHeading(category, t),
    [t]
  );
}
